import { Grid, Typography } from '@ts/storybook';
import { formatDate, IForm } from '@ts/ui-models';
import useFetchUser from '@utils/hooks/fetchData/useFetchUser';

interface IAuditDataEntityProps extends Omit<IForm, 'requiredFields' | 'onChange' | 'onCallbackChange'> {
  disabledNotifyChanges?: boolean;
}

const AuditDataEntity = (props: IAuditDataEntityProps) => {
  const { values, disabledNotifyChanges, mode } = props;
  if (mode === 'new') return null;
  if (!disabledNotifyChanges) return;

  const { updater, creator, creatorId, createdAt, updaterId, updatedAt } = values;
  const userList = useFetchUser([creatorId, updaterId]);

  const creationInfo = [
    'Created',
    ' ',
    'by',
    ' ',
    creator?.getName?.() ?? userList?.find(u => u.getID() === creatorId)?.getName(),
    ' ',
    'at',
    ' ',
    formatDate(createdAt),
  ];
  const updatedInfo = [
    'Last updated',
    ' ',
    'by',
    ' ',
    updater?.getName?.() ?? userList?.find(u => u.getID() === updaterId)?.getName(),
    ' ',
    'at',
    ' ',
    formatDate(updatedAt),
  ];

  return (
    <Grid container p={1} pr={2} direction={'column'}>
      <Typography variant="body2" className="text-gray-500" text={creationInfo} />
      <Typography variant="body2" className="text-gray-500" text={updatedInfo} />
    </Grid>
  );
};

export default AuditDataEntity;
